import mernStack from "../../assets/images/mern-stack.png";
import frontendDev from "../../assets/images/frontend-dev.png";
import backendDev from "../../assets/images/backend-dev.png";
import pythonFullStack from "../../assets/images/Python-full-stack-dev.png";
import javaFullStack from "../../assets/images/Java-full-stack-dev.png";

const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove all non-word chars
    .replace(/--+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
};

export const internships = [
  {
    id: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
    title: "Software Development Engineer Intern (MERN Stack)",
    company: "Codeblaze",
    category: "fullstack",
    price: 999,
    image: mernStack,
    location: "Bengaluru, KA, IN",
    duration: "12 Weeks",
    fees: "₹999",
    originalFees: "₹1999",
    discount: "50% OFF",
    batchSize: "60 Students",
    rating: 4.8,
    reviews: 124,
    level: "Intermediate",
    description:
      "Master full-stack development with MongoDB, Express.js, React, and Node.js. Build scalable web applications from scratch and deploy them to production. Work on 3 major projects including an e-commerce platform, social media app, and task management system.",
    highlights: [
      "Live project experience with real clients",
      "1-on-1 mentorship from senior developers",
      "Job placement assistance guaranteed",
      "Portfolio development with 3 major projects",
      "Industry-standard coding practices",
      "Agile development methodology",
      "Access to high-quality courses for all tech stacks",
    ],
    techStack: [
      "MongoDB",
      "Express.js",
      "React",
      "Node.js",
      "Redux",
      "JWT",
      "AWS",
      "Docker",
    ],
    requirements: [
      "Basic knowledge of JavaScript and HTML/CSS",
      "Completed at least 2 years of Computer Science or related field",
      "Strong problem-solving skills",
      "Commitment to 20+ hours per week",
    ],
    curriculum: [
      "Week 1-2: JavaScript ES6+ and Modern Development Tools",
      "Week 3-6: React.js and State Management with Redux",
      "Week 7-10: Node.js and Express.js Backend Development",
      "Week 11-14: MongoDB and Database Design",
      "Week 15-18: Authentication, Security, and API Development",
      "Week 19-24: Full-Stack Project Development and Deployment",
    ],
    deadline: "July 25, 2025",
    startDate: "August 1, 2025",
    certificate: "Industry-recognized completion certificate",
    placement: "95% placement rate",
    logo: "TF",
  },
  {
    id: "b2c3d4e5-f6a7-8901-2345-67890abcdef1",
    title: "Frontend Development Engineer Intern (React & Next.js)",
    company: "Codeblaze",
    category: "frontend",
    price: 799,
    image: frontendDev,
    location: "Bengaluru, KA, IN",
    duration: "12 Weeks",
    fees: "₹799",
    originalFees: "₹1499",
    discount: "47% OFF",
    batchSize: "60 Students",
    rating: 4.9,
    reviews: 89,
    level: "Beginner to Intermediate",
    description:
      "Become a frontend expert with React, Next.js, and modern UI/UX principles. Create responsive, interactive web applications with focus on performance optimization and user experience. Build professional-grade projects for your portfolio.",
    highlights: [
      "Master React ecosystem and Next.js framework",
      "Advanced CSS and design system implementation",
      "Performance optimization techniques",
      "Responsive design and mobile-first approach",
      "Component library development",
      "Real-world project collaboration",
      "Access to high-quality courses for all tech stacks",
    ],
    techStack: [
      "React",
      "Next.js",
      "TypeScript",
      "Tailwind CSS",
      "Framer Motion",
      "Figma",
      "Storybook",
      "Vercel",
    ],
    requirements: [
      "Basic understanding of HTML, CSS, and JavaScript",
      "Familiarity with Git and version control",
      "Design sense and attention to detail",
      "15+ hours per week availability",
    ],
    curriculum: [
      "Week 1-2: React Fundamentals and Modern JavaScript",
      "Week 3-4: Advanced React Patterns and Hooks",
      "Week 5-6: Next.js and Server-Side Rendering",
      "Week 7-8: Styling with Tailwind CSS and Animation",
      "Week 9-12: State Management and API Integration",
      "Week 13-16: Project Development and Deployment",
    ],
    deadline: "July 25, 2025",
    startDate: "August 1, 2025",
    certificate: "Frontend Development Specialization Certificate",
    placement: "92% placement rate",
    logo: "DC",
  },
  {
    id: "c3d4e5f6-a7b8-9012-3456-7890abcdef12",
    title: "Backend Development Engineer Intern (Node.js & Microservices)",
    company: "Codeblaze",
    category: "backend",
    price: 899,
    image: backendDev,
    location: "Bengaluru, KA, IN",
    duration: "12 Weeks",
    fees: "₹899",
    originalFees: "₹1799",
    discount: "50% OFF",
    batchSize: "60 Students",
    rating: 4.7,
    reviews: 76,
    level: "Intermediate to Advanced",
    description:
      "Deep dive into backend development with Node.js, microservices architecture, and cloud deployment. Learn to build scalable, secure APIs and work with modern database systems. Gain hands-on experience with DevOps practices and container technologies.",
    highlights: [
      "Microservices architecture implementation",
      "Advanced database design and optimization",
      "Cloud deployment with AWS/Azure",
      "DevOps practices and CI/CD pipelines",
      "API security and authentication",
      "Performance monitoring and scaling",
      "Access to high-quality courses for all tech stacks",
    ],
    techStack: [
      "Node.js",
      "Express.js",
      "PostgreSQL",
      "Redis",
      "Docker",
      "Kubernetes",
      "AWS",
      "GraphQL",
    ],
    requirements: [
      "Solid understanding of JavaScript and Node.js basics",
      "Database knowledge (SQL/NoSQL)",
      "Understanding of RESTful APIs",
      "25+ hours per week commitment",
    ],
    curriculum: [
      "Week 1-2: Advanced Node.js and Express.js",
      "Week 3-4: Database Design and Optimization",
      "Week 5-6: Authentication and Security",
      "Week 7-10: Microservices Architecture",
      "Week 11-14: Cloud Deployment and DevOps",
      "Week 15-20: Capstone Project and System Design",
    ],
    deadline: "July 25, 2025",
    startDate: "August 1, 2025",
    certificate: "Backend Engineering Professional Certificate",
    placement: "96% placement rate",
    logo: "CT",
  },
  {
    id: "d4e5f6a7-b8c9-0123-4567-890abcdef123",
    title: "Python Full-Stack Development Engineer (Django & React)",
    company: "Codeblaze",
    category: "python",
    price: 949,
    image: pythonFullStack,
    location: "Bengaluru, KA, IN",
    duration: "12 Weeks",
    fees: "₹949",
    originalFees: "₹1899",
    discount: "50% OFF",
    batchSize: "60 Students",
    rating: 4.8,
    reviews: 102,
    level: "Intermediate",
    description:
      "Master Python full-stack development with Django backend and React frontend. Build data-driven applications with advanced features like real-time analytics, machine learning integration, and automated testing. Perfect for aspiring data engineers and full-stack developers.",
    highlights: [
      "Python web development with Django",
      "Data analysis and visualization",
      "Machine learning model integration",
      "Advanced testing and debugging",
      "Database optimization with PostgreSQL",
      "Real-time features with WebSockets",
      "Access to high-quality courses for all tech stacks",
    ],
    techStack: [
      "Python",
      "Django",
      "React",
      "PostgreSQL",
      "Redis",
      "Celery",
      "Docker",
      "Pandas",
      "NumPy",
    ],
    requirements: [
      "Good understanding of Python programming",
      "Basic knowledge of web development concepts",
      "Mathematics and statistics background preferred",
      "20+ hours per week availability",
    ],
    curriculum: [
      "Week 1-2: Python Advanced Concepts and Django Basics",
      "Week 3-4: Django REST Framework and API Development",
      "Week 5-6: React Frontend and State Management",
      "Week 7-10: Database Design and Data Processing",
      "Week 11-16: Machine Learning Integration",
      "Week 17-24: Full-Stack Project and Deployment",
    ],
    deadline: "July 25, 2025",
    startDate: "August 1, 2025",
    certificate: "Python Full-Stack Developer Certificate",
    placement: "94% placement rate",
    logo: "DF",
  },
  {
    id: "e5f6a7b8-c9d0-1234-5678-90abcdef1234",
    title: "Java Full-Stack Development Engineer (Spring Boot & Angular)",
    company: "Codeblaze",
    category: "java",
    price: 999,
    image: javaFullStack,
    location: "Bengaluru, KA, IN",
    duration: "12 Weeks",
    fees: "₹999",
    originalFees: "₹1999",
    discount: "50% OFF",
    batchSize: "60 Students",
    rating: 4.9,
    reviews: 134,
    level: "Intermediate to Advanced",
    description:
      "Comprehensive Java enterprise development program covering Spring Boot, Angular, and enterprise-grade application development. Focus on building scalable, maintainable applications following industry best practices and design patterns.",
    highlights: [
      "Enterprise Java development with Spring Boot",
      "Modern frontend with Angular and TypeScript",
      "Microservices and distributed systems",
      "Enterprise security and authentication",
      "Performance tuning and optimization",
      "Industry mentorship and networking",
      "Access to high-quality courses for all tech stacks",
    ],
    techStack: [
      "Java",
      "Spring Boot",
      "Angular",
      "TypeScript",
      "MySQL",
      "MongoDB",
      "Apache Kafka",
      "Jenkins",
    ],
    requirements: [
      "Strong foundation in Java programming",
      "Object-oriented programming concepts",
      "Basic understanding of web technologies",
      "25+ hours per week commitment",
    ],
    curriculum: [
      "Week 1-2: Advanced Java and Spring Framework",
      "Week 3-4: Spring Boot and RESTful Services",
      "Week 5-6: Angular and TypeScript Fundamentals",
      "Week 7-10: Full-Stack Integration and Testing",
      "Week 11-16: Microservices and System Design",
      "Week 17-24: Enterprise Project and Deployment",
    ],
    deadline: "July 25, 2025",
    startDate: "August 1, 2025",
    certificate: "Java Enterprise Developer Certificate",
    placement: "97% placement rate",
    logo: "ES",
  },
  // {
  //   id: "f6a7b8c9-d0e1-2345-6789-0abcdef12345",
  //   title: "Test Internship for Payments",
  //   company: "Codeblaze",
  //   category: "testing",
  //   price: 2,
  //   image: "https://placehold.co/600x400/cccccc/000000?text=Test",
  //   location: "Bengaluru, KA, IN",
  //   duration: "1 Week",
  //   fees: "₹2",
  //   originalFees: "₹2",
  //   discount: "0% OFF",
  //   batchSize: "1 Student",
  //   rating: 5.0,
  //   reviews: 1,
  //   level: "Testing",
  //   description: "This is a test internship to validate the payment gateway integration.",
  //   highlights: [
  //     "Live project experience with real clients",
  //     "1-on-1 mentorship from senior developers",
  //   ],
  //   techStack: [
  //     "Testing"
  //   ],
  //   requirements: [
  //     "Being a test user"
  //   ],
  //   curriculum: [
  //     "Week 1: Testing payments"
  //   ],
  //   deadline: "July 31, 2025",
  //   startDate: "August 1, 2025",
  //   certificate: "Certificate of Testing",
  //   placement: "100% placement rate",
  //   logo: "TS",
  // },
];
